import script from "./percentage-complete.vue?vue&type=script&setup=true&lang=js"
export * from "./percentage-complete.vue?vue&type=script&setup=true&lang=js"

import "./percentage-complete.vue?vue&type=style&index=0&id=c0341a80&scoped=true&lang=scss"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0341a80"]])

export default __exports__